import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class EventsService {
  private readonly listeners = new Map<string, EventSubscription[]>();
  private readonly eventsSubject = new Subject<{ name: string; args: any[] }>();

  constructor() {
    this.eventsSubject.subscribe(({ name, args }) => {
      if (!this.listeners.has(name)) {
        return;
      }

      for (const eventSubscription of this.listeners.get(name)) {
        if (!eventSubscription?.listener) {
          continue;
        }

        if (eventSubscription.thisArg) {
          eventSubscription.listener.call(eventSubscription.thisArg, ...args);
        } else {
          eventSubscription.listener(...args);
        }
      }
    });
  }

  on(name: string, listener: any, thisArg?: any) {
    if (!this.listeners.has(name)) {
      this.listeners.set(name, []);
    }

    const subscription = new EventSubscription(listener, thisArg);
    this.listeners.get(name).push(subscription);

    return subscription;
  }

  unsubscribe(name: string, eventSubscription: EventSubscription) {
    if (!this.listeners.has(name)) {
      return;
    }

    const subscriptions = this.listeners.get(name);
    const index = subscriptions.indexOf(eventSubscription);
    if (index > -1) {
      subscriptions.splice(index, 1);
    }
  }

  broadcast(name: string, ...args: any[]) {
    this.eventsSubject.next({
      name,
      args
    });
  }

  // unSubscribe(name: string) {
  //   //this.listeners[name].unSubscribe();
  //   this.eventsSubject.unsubscribe();
  // }
}

export class EventSubscription {
  constructor(public listener: any, public thisArg: any) {}
}
